import { useQuery } from '@tanstack/react-query';
import { minutesToMilliseconds } from 'date-fns';

import meKeys from '@/api/queries/me/keyFactory';
import { apiFetch } from '@/utils/apiFetch';
import { DecoratedAccount } from '@payaca/types/accountTypes';
import { User } from '@payaca/types/userTypes';

// The account half is the exact wire contract (see DecoratedAccount); the
// user half is a partial declaration of the response.
export type MyRestProfile = User & {
  accounts: DecoratedAccount[];
  intercomHash: string;
};

export const fetchMyRestProfile = async (): Promise<MyRestProfile> => {
  const response = await apiFetch('/api/users/me');
  if (!response.ok) {
    throw new Error(`Failed to fetch profile: ${response.status}`);
  }
  return response.json() as Promise<MyRestProfile>;
};

/** The legacy REST profile (not the GraphQL me query). */
export const useGetMyRestProfile = () => {
  return useQuery({
    queryKey: meKeys.restProfile(),
    queryFn: fetchMyRestProfile,
    staleTime: minutesToMilliseconds(5),
    meta: { errorMessage: 'Failed to load your profile' },
  });
};
